<template>
  <div class="cart-infos">
    <p class="cart-title">{{ Translator('front.cart.infos.title')}}</p>
    <form class="std-form" @submit="onSubmit" ref="form">
      <div class="checkbox">
        <label>
          <input type="checkbox" v-model="form.isProfessional" @change="onChangeProfessional">
          {{ Translator('front.cart.infos.professional') }}
        </label>
      </div>
      <div class="form-row">
        <div class="form-group form-group--is-placeholder" :class="{'is-not-empty': form.shippingAddress.firstName }">
          <div class="form-label-container">
            <label for="firstName" class="control-label required">{{ Translator('front.cart.infos.firstName')}}</label>
          </div>
          <input type="text" id="firstName" class="form-control" v-model="form.shippingAddress.firstName" @focus="onFocus" @blur="onBlur" required>
        </div>
        <div class="form-group form-group--is-placeholder" :class="{'is-not-empty': form.shippingAddress.lastName }">
          <div class="form-label-container">
            <label for="lastName" class="control-label required">{{ Translator('front.cart.infos.lastName')}}</label>
          </div>
          <input type="text" id="lastName" class="form-control" v-model="form.shippingAddress.lastName" @focus="onFocus" @blur="onBlur" required>
        </div>
      </div>
      <div class="form-row">
        <div class="form-group form-group--is-placeholder" :class="{'is-not-empty': form.shippingAddress.phoneNumber }">
          <div class="form-label-container">
            <label for="shippingAddress.phoneNumber" class="control-label required">{{ Translator('front.cart.infos.phoneNumber')}}</label>
          </div>
          <input type="text" id="shippingAddress.phoneNumber" class="form-control" v-model="form.shippingAddress.phoneNumber" @focus="onFocus" @blur="onBlur" required>
        </div>
        <div></div>
      </div>
      <div class="form-group form-group--is-placeholder" :class="{'is-not-empty': form.shippingAddress.company }">
        <div class="form-label-container">
          <label for="shippingAddress.company" class="control-label">{{ Translator('front.cart.infos.shipping_company')}}</label>
        </div>
        <input type="text" id="shippingAddress.company" class="form-control" v-model="form.shippingAddress.company" @focus="onFocus" @blur="onBlur">
      </div>
      <div class="form-group form-group--is-placeholder" :class="{'is-not-empty': form.shippingAddress.street }">
        <div class="form-label-container">
          <label for="shippingAddress.street" class="control-label required">{{ Translator('front.cart.infos.street')}}</label>
        </div>
        <input type="text" id="shippingAddress.street" class="form-control" v-model="form.shippingAddress.street" @focus="onFocus" @blur="onBlur" required>
      </div>
      <div class="form-group form-group--is-placeholder" :class="{'is-not-empty': form.shippingAddress.complement }">
        <div class="form-label-container">
          <label for="shippingAddress.complement" class="control-label">{{ Translator('front.cart.infos.complement')}}</label>
        </div>
        <input type="text" id="shippingAddress.complement" class="form-control" v-model="form.shippingAddress.complement" @focus="onFocus" @blur="onBlur">
      </div>
      <div class="form-row">
        <div class="form-group form-group--is-placeholder" :class="{'is-not-empty': form.shippingAddress.postcode }">
          <div class="form-label-container">
            <label for="shippingAddress.postcode" class="control-label required">{{ Translator('front.cart.infos.postcode')}}</label>
          </div>
          <input type="text" id="shippingAddress.postcode" class="form-control" v-model="form.shippingAddress.postcode" @focus="onFocus" @blur="onBlur" required>
        </div>
        <div class="form-group form-group--is-placeholder" :class="{'is-not-empty': form.shippingAddress.city }">
          <div class="form-label-container">
            <label for="shippingAddress.city" class="control-label required">{{ Translator('front.cart.infos.city')}}</label>
          </div>
          <input type="text" id="shippingAddress.city" class="form-control" v-model="form.shippingAddress.city" @focus="onFocus" @blur="onBlur" required>
        </div>
        <div class="form-group form-group--is-placeholder" :class="{'is-not-empty': form.shippingAddress.countryCode }">
          <div class="form-label-container">
            <label for="shippingAddress.countryCode" class="control-label required">{{ Translator('front.cart.infos.countryCode')}}</label>
          </div>
          <select id="shippingAddress.countryCode" class="form-control" v-model="form.shippingAddress.countryCode" @focus="onFocus" @blur="onBlur" required>
            <option :value="country.code" v-for="country in countries" :key="country.id">{{ country.name }}</option>
          </select>
        </div>
      </div>
      <hr>
      <div class="checkbox">
        <label>
          <input type="checkbox" v-model="form.useShippingAddressAsBillingAddress" @change="onChangeSameAddress">
          {{ Translator('front.cart.infos.same_address') }}
        </label>
      </div>
      <div v-if="form.isProfessional">
        <div class="form-row">
          <div class="form-group form-group--is-placeholder" :class="{'is-not-empty': form.billingAddress.company }">
            <div class="form-label-container">
              <label for="billingAddress.company" class="control-label required">{{ Translator('front.cart.infos.company')}}</label>
            </div>
            <input type="text" id="billingAddress.company" class="form-control" v-model="form.billingAddress.company" @focus="onFocus" @blur="onBlur" required>
          </div>
          <div></div>
        </div>
        <div class="form-row">
          <!-- Business rule: only SIREN is ever mandatory (French professional). VAT
               number and company registration number stay optional ("facultatif")
               even when the zone shows them - VIES validates the format/registration
               when filled in, but neither is a hard requirement to submit. -->
          <div v-if="proZoneRequirements.requiresVatNumber" class="form-group form-group--is-placeholder" :class="{'is-not-empty': form.billingAddress.vatNumber }">
            <div class="form-label-container">
              <label for="billingAddress.vatNumber" class="control-label">{{ Translator('front.cart.infos.vat_number')}}</label>
            </div>
            <input type="text" id="billingAddress.vatNumber" class="form-control" v-model="form.billingAddress.vatNumber" @focus="onFocus" @blur="onBlur">
            <p v-if="formErrors.vatNumber" class="vies-status vies-status--invalid">{{ formErrors.vatNumber }}</p>
            <p v-else-if="form.billingAddress.viesValid === true" class="vies-status vies-status--valid">{{ Translator('front.cart.infos.vies_valid') }}</p>
            <p v-else-if="form.billingAddress.viesValid === false" class="vies-status vies-status--invalid">{{ Translator('front.cart.infos.vies_invalid') }}</p>
          </div>
          <div v-if="proZoneRequirements.requiresSiren" class="form-group form-group--is-placeholder" :class="{'is-not-empty': form.billingAddress.siren }">
            <div class="form-label-container">
              <label for="billingAddress.siren" class="control-label required">{{ Translator('front.cart.infos.siren')}}</label>
            </div>
            <input type="text" id="billingAddress.siren" class="form-control" v-model="form.billingAddress.siren" @focus="onFocus" @blur="onBlur" required>
            <p v-if="formErrors.siren" class="vies-status vies-status--invalid">{{ formErrors.siren }}</p>
          </div>
          <div v-if="proZoneRequirements.requiresCompanyRegistrationNumber" class="form-group form-group--is-placeholder" :class="{'is-not-empty': form.billingAddress.companyRegistrationNumber }">
            <div class="form-label-container">
              <label for="billingAddress.companyRegistrationNumber" class="control-label">{{ Translator('front.cart.infos.company_registration_number')}}</label>
            </div>
            <input type="text" id="billingAddress.companyRegistrationNumber" class="form-control" v-model="form.billingAddress.companyRegistrationNumber" @focus="onFocus" @blur="onBlur">
            <p v-if="formErrors.companyRegistrationNumber" class="vies-status vies-status--invalid">{{ formErrors.companyRegistrationNumber }}</p>
          </div>
        </div>
        <p v-if="formErrors._generic" class="vies-status vies-status--invalid">{{ formErrors._generic }}</p>
      </div>
      <div v-if="!form.useShippingAddressAsBillingAddress" class="cart-infos-billing">

        <div class="form-row">
          <div class="form-group form-group--is-placeholder" :class="{'is-not-empty': form.billingAddress.firstName }">
            <div class="form-label-container">
              <label for="billingAddress.firstName" class="control-label required">{{ Translator('front.cart.infos.firstName')}}</label>
            </div>
            <input type="text" id="billingAddress.firstName" class="form-control" v-model="form.billingAddress.firstName" @focus="onFocus" @blur="onBlur" required>
          </div>
          <div class="form-group form-group--is-placeholder" :class="{'is-not-empty': form.billingAddress.lastName }">
            <div class="form-label-container">
              <label for="billingAddress.lastName" class="control-label required">{{ Translator('front.cart.infos.lastName')}}</label>
            </div>
            <input type="text" id="billingAddress.lastName" class="form-control" v-model="form.billingAddress.lastName" @focus="onFocus" @blur="onBlur" required>
          </div>
        </div>
        <div class="form-row">
          <div class="form-group form-group--is-placeholder" :class="{'is-not-empty': form.billingAddress.phoneNumber }">
            <div class="form-label-container">
              <label for="billingAddress.phoneNumber" class="control-label required">{{ Translator('front.cart.infos.phoneNumber')}}</label>
            </div>
            <input type="text" id="billingAddress.phoneNumber" class="form-control" v-model="form.billingAddress.phoneNumber" @focus="onFocus" @blur="onBlur" required>
          </div>
          <div></div>
        </div>
        <div class="form-group form-group--is-placeholder" :class="{'is-not-empty': form.billingAddress.street }">
          <div class="form-label-container">
            <label for="billingAddress.street" class="control-label required">{{ Translator('front.cart.infos.street')}}</label>
          </div>
          <input type="text" id="billingAddress.street" class="form-control" v-model="form.billingAddress.street" @focus="onFocus" @blur="onBlur" required>
        </div>
        <div class="form-group form-group--is-placeholder" :class="{'is-not-empty': form.billingAddress.complement }">
          <div class="form-label-container">
            <label for="billingAddress.complement" class="control-label">{{ Translator('front.cart.infos.complement')}}</label>
          </div>
          <input type="text" id="billingAddress.complement" class="form-control" v-model="form.billingAddress.complement" @focus="onFocus" @blur="onBlur">
        </div>
        <div class="form-row">
          <div class="form-group form-group--is-placeholder" :class="{'is-not-empty': form.billingAddress.postcode }">
            <div class="form-label-container">
              <label for="billingAddress.postcode" class="control-label required">{{ Translator('front.cart.infos.postcode')}}</label>
            </div>
            <input type="text" id="billingAddress.postcode" class="form-control" v-model="form.billingAddress.postcode" @focus="onFocus" @blur="onBlur" required>
          </div>
          <div class="form-group form-group--is-placeholder" :class="{'is-not-empty': form.billingAddress.city }">
            <div class="form-label-container">
              <label for="billingAddress.city" class="control-label required">{{ Translator('front.cart.infos.city')}}</label>
            </div>
            <input type="text" id="billingAddress.city" class="form-control" v-model="form.billingAddress.city" @focus="onFocus" @blur="onBlur" required>
          </div>
          <div class="form-group form-group--is-placeholder" :class="{'is-not-empty': form.billingAddress.countryCode }">
            <div class="form-label-container">
              <label for="billingAddress.countryCode" class="control-label required">{{ Translator('front.cart.infos.countryCode')}}</label>
            </div>
            <select id="billingAddress.countryCode" class="form-control" v-model="form.billingAddress.countryCode" @focus="onFocus" @blur="onBlur" required>
              <option :value="country.code" v-for="country in countries" :key="country.id">{{ country.name }}</option>
            </select>
          </div>
        </div>

      </div>
      <button type="submit">{{ Translator('front.cart.resume.buttons.step_2') }}</button>
    </form>
  </div>
</template>
<style scoped lang="scss">
  .cart-infos {
    hr {
      width: 100%;
      border: 0;
      border-top: rem(1) solid $grey-light;
      margin-top: rem(10);
      margin-bottom: rem(25);
    }
    .checkbox {
      margin-bottom: rem(30);
    }
    .cart-infos-billing {
      padding-top: rem(30);
    }
    .vies-status {
      margin: rem(4) 0 0;
      font-size: rem(12);
      &--valid {
        color: $color-success;
      }
      &--invalid {
        color: $color-error;
      }
    }
  }
  button[type="submit"] {
    display: none;
  }
</style>
<script>
import axios from 'axios';
import AppControlService from '@/services/AppControl';
import UsersService from '@/services/Users';
import FormControl from 'aw-front-helpers/classes/formControl';
import OrdersService from '@/services/Orders';

export default {
  name: 'cart-infos',
  components: {},
  data () {
    return {
      countries: UsersService.countries,
      form: {
        useShippingAddressAsBillingAddress: true,
        isProfessional: false,
        shippingAddress: {
          firstName: null,
          lastName: null,
          phoneNumber: null,

          company: null,
          street: null,
          complement: null,
          city: null,
          postcode: null,
          countryCode: 'FR'
        },
        billingAddress: {
          firstName: null,
          lastName: null,
          phoneNumber: null,

          vatNumber: null,
          siren: null,
          companyRegistrationNumber: null,
          company: null,
          street: null,
          complement: null,
          city: null,
          postcode: null,
          countryCode: 'FR',
          viesValid: null
        }
      },
      // Hidden by default until the zone lookup resolves (see _fetchProZoneRequirements) -
      // defaulting any of these to true flashes that field visible on arrival, before we
      // actually know which one(s) the billing country requires.
      proZoneRequirements: {
        requiresVatNumber: false,
        requiresSiren: false,
        requiresCompanyRegistrationNumber: false
      },
      // Keyed by field name (siren, vatNumber, companyRegistrationNumber), populated
      // from the API's validation error response on a failed submit; _generic holds
      // any violation that doesn't map to a known field.
      formErrors: {}
    }
  },
  computed: {
    billingCountryCode() {
      return this.form.useShippingAddressAsBillingAddress
        ? this.form.shippingAddress.countryCode
        : this.form.billingAddress.countryCode;
    }
  },
  watch: {
    billingCountryCode: {
      immediate: true,
      handler(countryCode) {
        this._fetchProZoneRequirements(countryCode);
      }
    }
  },
  created() {
    this.onNextStep = this.onNextStep.bind(this);
    this._onInitDatas = this._onInitDatas.bind(this);
    this._onUpdateCountries = this._onUpdateCountries.bind(this);
    UsersService.on('countries', this._onUpdateCountries);
    UsersService.on('update', this._onInitDatas);
    AppControlService.on('validating', this.onNextStep);
  },
  mounted() {
    this._onInitDatas();
    this._onUpdateCountries();
  },

  beforeDestroy() {
    this._form.destroy();
    UsersService.off('countries', this._onUpdateCountries);
    UsersService.off('update', this._onInitDatas);
    AppControlService.off('validating', this.onNextStep);
  },
  methods: {
    onNextStep() {
      this.$refs.form.querySelector('button[type="submit"]').click();
    },

    onSubmit(pEvt) {
      pEvt.preventDefault();
      if(this._isSubmited) return;
      this._isSubmited = true;
      this.formErrors = {};
      if(this._form.isValidate) {
        const userDatas = JSON.parse(JSON.stringify(this.form));
        const orderDatas = {
          shippingAddress: { ...userDatas.shippingAddress },
        }
        orderDatas.billingAddress = this.form.useShippingAddressAsBillingAddress ? { ...userDatas.shippingAddress } : { ...userDatas.billingAddress };

        const calls = [];
        orderDatas.shippingAddress.isShipping = true;
        orderDatas.billingAddress.isShipping = false;

        // The professional flag is stored on the user (orderAsProfessional). The business
        // fields (company, SIREN, VAT) live on the billing address; re-apply them so they
        // are kept even when the billing address is a copy of the shipping address.
        if (this.form.isProfessional) {
          orderDatas.billingAddress.company = userDatas.billingAddress.company;
          // Only re-send fields the *current* zone still requires - v-if only hides
          // these inputs, it doesn't reset form.billingAddress.*, so without this
          // gate a value entered for a previous country (e.g. an Italian VAT number)
          // would keep being resubmitted after switching back to a country that
          // doesn't need it.
          orderDatas.billingAddress.siren = this.proZoneRequirements.requiresSiren ? userDatas.billingAddress.siren : null;
          orderDatas.billingAddress.companyRegistrationNumber = this.proZoneRequirements.requiresCompanyRegistrationNumber ? userDatas.billingAddress.companyRegistrationNumber : null;
          orderDatas.billingAddress.vatNumber = this.proZoneRequirements.requiresVatNumber ? userDatas.billingAddress.vatNumber : null;
          if (this.form.useShippingAddressAsBillingAddress) {
            // Keep the billing address's own identity: company/VAT/SIREN can't live on
            // the shipping-flagged row, so even when "same as shipping" is checked this
            // must stay a distinct Address record (with shipping's physical details,
            // but its own id) rather than literally reusing the shipping row.
            orderDatas.billingAddress.id = userDatas.billingAddress.id;
          }
        } else {
          orderDatas.billingAddress.company = null;
          orderDatas.billingAddress.siren = null;
          orderDatas.billingAddress.companyRegistrationNumber = null;
          orderDatas.billingAddress.vatNumber = null;
        }
        if(orderDatas.shippingAddress?.id) calls.push(UsersService.updateAddress(orderDatas.shippingAddress?.id, orderDatas.shippingAddress))
        else calls.push(UsersService.addAddress(orderDatas.shippingAddress))

        // Persist the billing address as its own account record whenever it's not a
        // pure alias of the shipping row - i.e. always when unchecked, and also when
        // professional even if "same as shipping" is checked (see comment above).
        if(!this.form.useShippingAddressAsBillingAddress || this.form.isProfessional) {
          if(orderDatas.billingAddress?.id) calls.push(UsersService.updateAddress(orderDatas.billingAddress?.id, orderDatas.billingAddress))
          else calls.push(UsersService.addAddress(orderDatas.billingAddress))
        }

        Promise.all(calls).then( ([shipping, billing]) => {
          const userDatas = {
            addresses: [],
            useShippingAddressAsBillingAddress: this.form.useShippingAddressAsBillingAddress,
            orderAsProfessional: this.form.isProfessional
          }
          userDatas.addresses.push( shipping.data['@id'] );
          if(billing) userDatas.addresses.push( billing.data['@id'] );

          // Must be awaited (not fired concurrently with the order PATCH below):
          // ProfessionalZoneTaxesProcessor reads User.orderAsProfessional straight
          // from the DB during the order PATCH's synchronous tax reprocessing. If
          // both requests raced, the order PATCH could read the flag before this
          // PATCH committed it, silently skipping the professional zone's tax on
          // the very first submit.
          UsersService.update(UsersService.datas.id, userDatas).then( () => {
            delete orderDatas.shippingAddress['@id'];
            delete orderDatas.shippingAddress['@type'];
            delete orderDatas.shippingAddress.id;
            delete orderDatas.billingAddress['@id'];
            delete orderDatas.billingAddress['@type'];
            delete orderDatas.billingAddress.id;

            return OrdersService.update(orderDatas);
          }).then( () => {
            AppControlService.goToNextStep();
          }).catch((err) => {
            console.error(err);
            this._applyApiErrors(err);
            AppControlService.abortStep();
          }).then( () => {
            this._isSubmited = false;
          });
        }).catch( (err) => {
          console.error(err);
          this._isSubmited = false;
          this._applyApiErrors(err);
          AppControlService.abortStep();
        })
      } else {
        this._isSubmited = false;
        AppControlService.abortStep();
      }
    },

    // Maps an API Platform validation error response (422, hydra ConstraintViolationList)
    // onto formErrors so it can be shown next to the relevant field. propertyPath is a
    // bare field name ("siren") when the /api/v2/addresses resource itself rejects the
    // value, or a nested path ("billingAddress.siren") when it's the order PATCH's
    // cascaded Address validation instead - take the last segment either way. Any error
    // that isn't a recognized validation payload (network failure, 500, etc.) falls back
    // to a generic message rather than failing silently.
    _applyApiErrors(err) {
      const violations = err?.response?.data?.violations;
      if (Array.isArray(violations) && violations.length) {
        violations.forEach(violation => {
          const field = String(violation.propertyPath || '').split('.').pop();
          this.formErrors = { ...this.formErrors, [field || '_generic']: violation.message };
        });
      } else {
        this.formErrors = { ...this.formErrors, _generic: this.Translator('front.cart.infos.error.generic') };
      }
    },

    onChangeSameAddress() {
      this._updateForm();
    },

    onChangeProfessional() {
      this._updateForm();
    },

    onFocus(pEvt) {
      pEvt.target.closest('.form-group').classList.add('is-focus');
    },

    onBlur(pEvt) {
      const el = pEvt.target;
      const group =  el.closest('.form-group');
      group.classList.remove('is-focus');

      let isEmpty = true;
      if ((el.tagName === 'INPUT' || el.tagName === 'SELECT') && el.value !== '') isEmpty = false;
      else if (el.tagName === 'TEXTAREA' && el.value !== '') isEmpty = false;
      group.classList.toggle('is-not-empty', !isEmpty);
    },

    _updateForm() {
      if(this._form) this._form.destroy();
      setTimeout(() => {
        if(this.$refs.form) {
          this._form = new FormControl(this.$refs.form, {
            parentElementClass: '.form-group'
          });
        }
      });
    },

    _onUpdateCountries() {
      this.countries = UsersService.countries;
    },

    _fetchProZoneRequirements(countryCode) {
      if (!countryCode) return;
      axios.get(`/api/v2/zones/professional-requirements/${countryCode}`).then((res) => {
        // Guard against out-of-order responses: the billingCountryCode watcher's
        // `immediate: true` fires once with the default 'FR' at component setup,
        // before mounted()'s _onInitDatas() corrects it to the real saved country
        // (e.g. 'IT') - so on every remount (re-entering this checkout step) two
        // requests for different countries are in flight, and the network gives no
        // guarantee the first one sent resolves first. Applying a stale response
        // here would silently show the wrong country's requirements (e.g. SIREN
        // instead of VAT number for an Italian billing address).
        if (countryCode !== this.billingCountryCode) return;
        this.proZoneRequirements = {
          requiresVatNumber: !!res.data.requiresVatNumber,
          requiresSiren: !!res.data.requiresSiren,
          requiresCompanyRegistrationNumber: !!res.data.requiresCompanyRegistrationNumber
        };
        // The fields shown/required just changed (v-if) - FormControl snapshots the
        // DOM at construction time and doesn't track subsequent mutations, so it must
        // be rebuilt or it validates against stale/removed fields (silently breaking
        // submit), same as onChangeProfessional/onChangeSameAddress already do.
        this.$nextTick(() => this._updateForm());
      }).catch(console.error);
    },

    _onInitDatas() {
      if(UsersService.datas) {
        this.form.shippingAddress = {
          ...UsersService.datas.defaultShippingAddress
        }
        this.form.billingAddress = {
          ...UsersService.datas.defaultBillingAddress
        }
        this.form.useShippingAddressAsBillingAddress = UsersService.datas.useShippingAddressAsBillingAddress
        this.form.isProfessional = !!UsersService.datas.orderAsProfessional
      }
      this._updateForm();
    },

    Translator(key, datas = null) {
      return window.Translator.trans(key, datas);
    },
  }
};
</script>
